module.exports = __webpack_public_path__ + "img/fanganbanner_sample.bd3570d4.png";